<template>
  <v-container fluid>
    <v-row v-if="pdfs && pdfs.length > 0">
      <v-col v-for="pdf in parsedPDFs" :key="pdf.url"
        cols="12" sm="6" xl="3" lg="4"
      >
        <AmtstafelCard :label="pdf.txt" :pdf="pdf.url" :main-color="mainColor" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import axios from 'axios'
  import { encode, escape } from 'base64-url'

  import AmtstafelCard from './AmtstafelCard.vue'

  export default {
    name: 'AmtstafelStleonhard',
    props: ["startUrl", "mainColor"],
    components: {
      AmtstafelCard
    },
    computed: {
      parsedPDFs(){
        return this.pdfs.flat()
      }
    },
    methods: {
      async pdfsFromPage(url){
        const encodedUrl = escape(encode(url))
        const response = await axios({
          url: `https://graphql.sta.io/proxy/bsBi1mr1F/${encodedUrl}`
        })
        const dom = new DOMParser().parseFromString(response.data, "text/html")
        const pdfs = [...dom.querySelectorAll('div.amtstafel_tabelle tbody a.piwik_download')].map(a => {
          const pdfUrl = new URL(a.getAttribute('href'), url).toString()
          const txt = a.textContent
          return { url: pdfUrl, txt }
        })
        return pdfs
      },
      load(){
        this.getPages()
      },
      async getPages(){
        const encodedStartUrl = escape(encode(this.startUrl))
        const response = await axios({
          url: `https://graphql.sta.io/proxy/bsBi1mr1F/${encodedStartUrl}`
        })

        const dom = new DOMParser().parseFromString(response.data, "text/html")
        const pageLinks = dom.querySelectorAll('p.pager_container a.pager')
        let urls = new Set([...pageLinks].map(link => {
          return new URL(link.getAttribute("href"), this.startUrl).toString()
        }))

        if (urls && urls.length == 0){
            urls = [this.startUrl]
        }

        this.pdfs = await Promise.all([this.startUrl, ...urls].map(url => {
          console.log("url", url)
          return this.pdfsFromPage(url)
        }))
      }
    },
    mounted(){
      this.load()
      setInterval(() => {
        this.load()
      }, 1000*60*5)
    },
    watch: {
      startUrl(){
        this.load()
      }
    },
    data: () => ({
      dom: null,
      pdfs: null,
    }),
  }
</script>
